// Management Slider Data
export const sections = [
    'Global Policies',
    'Risks and Security',
    'Business Description',
    'Process Map',
    'Activity Bible',
    'Product and Process Indicators',
    'Standards Creation & Execution',
    'MCRs',
    'Frontline Problem Solving',
    'Project Management',

    // 'Change Management',
    'Customer Centricity',
];

export const sectionPaths: { [key: string]: string } = {
    'Business Description': '/operations/management/business-description',
    'Process Map': '/operations/management/process-map',
    'Activity Bible': '/operations/management/activity-bible',
    'MCRs': '/operations/management/mcrs',
    'Global Policies': '/operations/management/global-policies',
    'Project Management': '/operations/management/project-management',
    'Frontline Problem Solving': '/operations/management/frontline-problem-solving',
    'Continuous Improvement': '/operations/management/continuous-improvement',
    'Quality Control': '/operations/management/quality-control',
    'Resource Management': '/operations/management/resource-management',
    'Risks and Security': '/operations/management/risk-security',
    'Product and Process Indicators': '/operations/management/product-and-process-indicators',
    // 'Change Management': '/operations/management/change-management/manager',
    'Customer Centricity': '/operations/management/customer-centricity',
    'Standards Creation & Execution': '/operations/management/standard-creation-execution'
};

// Strategy a& Value Creation Data

export const sectionsStrategyCreation = [
    'GBS CAPEX and OPEX Allocation',
    'Business Cycle and Value Creation Process',
    'Inflow and New demand Process', 
    'GBS Cross-charge process'

]

export const sectionsStrategyCreationPaths: { [key: string]: string } = {
    'GBS CAPEX and OPEX Allocation': '/operations/strategy-value-creation/vctra/capex-opex',
    'Business Cycle and Value Creation Process': '/operations/strategy-value-creation/vctra/bcvcp',
    'Inflow and New demand Process': '/operations/strategy-value-creation/vctra/indp',
    'GBS Cross-charge process':'/operations/strategy-value-creation/vctra/gccp'
};

